import { z } from 'zod';

/** A declared end-of-treatment measurement, not a certificate of the whole process. */
export const ChillingCheckSchema = z.object({
  version: z.literal(1),
  core_temp_c: z.number().finite().min(-100).max(150),
  measured_at: z.string().datetime(),
  target_temp_c: z.number().finite().min(-100).max(150),
  planned_minutes: z.number().finite().nonnegative().nullable(),
}).strict().refine(check => check.core_temp_c <= check.target_temp_c, { message: 'Temperatura obiettivo non raggiunta' });
export type ChillingCheck = z.infer<typeof ChillingCheckSchema>;

export function buildChillingCheck(input: { temperature: string; measuredAt: string; target: number | null | undefined; plannedMinutes?: number | null }): ChillingCheck {
  if (!input.temperature.trim()) throw new Error('Inserisci la temperatura misurata al cuore a fine abbattimento');
  if (input.target == null || !Number.isFinite(input.target)) throw new Error('Configura la temperatura obiettivo di abbattimento nella ricetta');
  const temperature = Number(input.temperature.replace(',', '.'));
  if (!Number.isFinite(temperature) || temperature < -100 || temperature > 150) throw new Error('Temperatura al cuore non valida');
  if (temperature > input.target) throw new Error('Temperatura obiettivo non raggiunta: verifica il trattamento prima di stampare e registra l’eventuale non conformità');
  const measured = new Date(input.measuredAt);
  if (!Number.isFinite(measured.getTime()) || measured.getTime() > Date.now() + 60_000) throw new Error('Indica data e ora effettive della misura, non nel futuro');
  return ChillingCheckSchema.parse({ version: 1, core_temp_c: temperature, measured_at: measured.toISOString(), target_temp_c: input.target, planned_minutes: input.plannedMinutes ?? null });
}
